import { render, staticRenderFns } from "./verifyTransactionWithoutAuthentication.vue?vue&type=template&id=0c4b9c5b"
import script from "./verifyTransactionWithoutAuthentication.vue?vue&type=script&lang=js"
export * from "./verifyTransactionWithoutAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports